import { render, staticRenderFns } from "./FormCrudReseller.vue?vue&type=template&id=63435355&scoped=true"
import script from "./FormCrudReseller.vue?vue&type=script&lang=js"
export * from "./FormCrudReseller.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63435355",
  null
  
)

export default component.exports